export const FETCH_PRODUCT_GEOBLOCK_GROUPS_LOADING =
	'FETCH_PRODUCT_GEOBLOCK_GROUPS_LOADING';
export const FETCH_PRODUCT_GEOBLOCK_GROUPS_SUCCESS =
	'FETCH_PRODUCT_GEOBLOCK_GROUPS_SUCCESS';
export const FETCH_PRODUCT_GEOBLOCK_GROUPS_ERROR =
	'FETCH_PRODUCT_GEOBLOCK_GROUPS_ERROR';
